// @ts-nocheck
// redesign.tsx — choishin 리디자인 프리뷰 라우트 모음
//
// 이식 파일(`src/redesign/**`)은 claude.ai/design 캔버스 산출물이라
// `.jsx`로 두어 메인 tsconfig(strict·noUnusedLocals) 검사 대상에서 제외했다.
// 이 파일은 그 .jsx들을 한 곳에서 import해 라우트 배열로 노출하는 어댑터.
// `@ts-nocheck`로 .jsx 모듈 해석 에러를 격리한다. (Vite/esbuild가 .jsx 빌드)

import { lazy } from 'react';
import { Route } from 'react-router-dom';
// H-2 코드 스플리팅(2026-07-05 코드감사) — 리디자인 프리뷰는 검수 전용이라 실사용 0.
// 전량 lazy 로 분리해 초기 번들에서 제외(상위 Suspense가 fallback 커버).
const RedesignIndex = lazy(() => import('../redesign/RedesignIndex'));
const RedesignFinance = lazy(() => import('../redesign/pages/finance'));
const RedesignBudget = lazy(() => import('../redesign/pages/budget'));
const RedesignCommunity = lazy(() => import('../redesign/pages/community'));
const RedesignBotpost = lazy(() => import('../redesign/pages/botpost'));
const RedesignOnboarding = lazy(() => import('../redesign/pages/onboarding'));
const RedesignMbti = lazy(() => import('../redesign/pages/mbti'));
const RedesignMbtiFlow = lazy(() => import('../redesign/pages/mbti-flow'));
const RedesignExtras = lazy(() => import('../redesign/pages/extras'));
// A그룹 claude.ai/design 리디자인 이식 (live/) — 금융설명부터 PoC
const RedesignFinanceAbout = lazy(() => import('../redesign/live/FinanceAboutScreen'));
const RedesignCollection = lazy(() => import('../redesign/live/CollectionScreen'));
// ⚠ 게임 프리뷰(games-*·game-portfolio·ChartGame·Toto·GamePick)는 2026-06-14 v1 스코프 좁히기로 _archive 은퇴

// react-router v6 — <Routes> children으로 펼쳐 쓸 <Route> 배열
export const redesignRoutes = [
  <Route key="rd-index"      path="/redesign"            element={<RedesignIndex />} />,
  <Route key="rd-finance"    path="/redesign/finance"    element={<RedesignFinance />} />,
  <Route key="rd-budget"     path="/redesign/budget"     element={<RedesignBudget />} />,
  <Route key="rd-community"  path="/redesign/community"  element={<RedesignCommunity />} />,
  <Route key="rd-botpost"    path="/redesign/botpost"    element={<RedesignBotpost />} />,
  <Route key="rd-onboarding" path="/redesign/onboarding" element={<RedesignOnboarding />} />,
  <Route key="rd-mbti"       path="/redesign/mbti"       element={<RedesignMbti />} />,
  <Route key="rd-mbti-flow"  path="/redesign/mbti-flow"  element={<RedesignMbtiFlow />} />,
  <Route key="rd-extras"         path="/redesign/extras"         element={<RedesignExtras />} />,
  <Route key="rd-finance-about"  path="/redesign/finance-about"  element={<RedesignFinanceAbout />} />,
  <Route key="rd-collection"     path="/redesign/collection"     element={<RedesignCollection />} />,
];
